
<!-- Modal -->
<div class="modal fade" *ngIf="adminApi.isLoggedIn()" id="{{modalid}}" tabindex="-1" aria-labelledby="suggestskillModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form class="" [formGroup]="Form" (ngSubmit)="onSubmit(Form)" enctype="multipart/form-data">
        <div class="modal-body pt-4">
          <h5 class="card-title">{{video?  "Edit Video": "New Video"}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="form-group">
              <label class="form-label">Video Name</label>
              <input type="text" class="form-control" formControlName="name">
              <div class="invalid-feedback d-block"
                  *ngIf="f2['name'].errors?.['required'] && (f2['name'].dirty || f2['name'].touched)">
                  Please fill name.
              </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label d-block">Video</label>
                <input type="file" #fileUploader formControlName="video" id="videofile" accept="video/mp4,video/3gp" (change)="onSelectFile($event)">
                <div class="invalid-feedback d-block"
                    *ngIf="f2['video'].errors?.['required'] && (f2['video'].dirty || f2['video'].touched)">
                    Please select mp4 or 3gp video.
                </div>
                <br *ngIf="videourl"/>
                <br *ngIf="videourl"/>
                <video oncontextmenu="return false;" controlsList="nodownload" [src]="videourl" id="video" *ngIf="videourl" height="100" controls></video> 
                <br/>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="form-label d-block">Thumbnail</label>
                <input type="file" formControlName="thumbnail" accept="image/jpg,image/jpeg,image/png" (change)="onSelectFile($event)">
                <div class="invalid-feedback d-block"
                    *ngIf="f2['thumbnail'].errors?.['required'] && (f2['thumbnail'].dirty || f2['thumbnail'].touched)">
                    Please select png, jpeg or jpg image.
                </div>
                <br *ngIf="imageurl"/>
                <br *ngIf="imageurl"/>
                <img [src]="imageurl" *ngIf="imageurl" height="100">
                <br/>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Description</label>
            <editor
            id="editor"
            formControlName="description"
            [init]="{ plugins: 'lists link image table code help wordcount' }"
            (onInit)="handleEvent($event)"
          ></editor>
            <!-- <textarea class="form-control h-auto" formControlName="description"></textarea> -->
          </div>
          <div class="form-group">
            <label class="form-label">Difficulty Rating</label>
            <input type="number" class="form-control" formControlName="difficulty_rating">
            <small>Between 1-5</small>
          </div>
          
          <label class="form-label">Level Types</label>
          <hr/>
          <ng-container formArrayName="formrules">
            <ng-container *ngFor="let formrulesForm of formrules?.controls; let i = index">
              <div class="row mb-2" [formGroupName]="i">
                <div class="col-md-5 form-group">
                  <label class="form-label">Rule</label>
                  <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="rule" title="Select Rule" class="selectpicker rule font-oswald w-100">
                    <option value="">Select Rule</option>
                    <option *ngFor="let selectrule of allrules" [value]="selectrule?.id">{{selectrule?.name | titlecase}}</option>
                  </select>
                  <div class="invalid-feedback d-block"
                      *ngIf="f2['formrules']['controls'][i]['controls'].rule?.errors?.['required'] && f2['formrules']['controls'][i]['controls'].rule?.touched && f2['formrules']['controls'][i]['controls'].rule?.invalid">
                      Please select rule.
                  </div>
                </div>
                <div class="col-md-5 form-group">
                  <label class="form-label">Level</label>
                  <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="level" title="Select Level" class="selectpicker level font-oswald w-100">
                    <option value="">Select Level</option>
                    <option *ngFor="let selectrule of alllevels" [value]="selectrule?.id">{{selectrule?.name | titlecase}}</option>
                  </select>
                  <div class="invalid-feedback d-block"
                      *ngIf="f2['formrules']['controls'][i]['controls'].level?.errors?.['required'] && f2['formrules']['controls'][i]['controls'].level?.touched && f2['formrules']['controls'][i]['controls'].level?.invalid">
                      Please select level.
                  </div>
                </div>
                
                <div class="col-md-2 form-group">
                  <label class="form-label">Remove</label>
                  <div>
                    <button class="btn btn-sm btn-danger" (click)="deleteformrules(i)"><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </div>
              <hr/>
            </ng-container>
          </ng-container>
          <button type="button" class="btn btn-secondary btn-sm me-3" (click)="addRule()">Add Level Type</button>
          <br/>
          <br/>
          <div class="">
            <div class="form-group">
              <label class="form-label">Movement Category</label>
              <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="formcategory" title="Select Category" class="selectpicker category font-oswald w-100"  (change)="changeCategory($event)">
                <option value="">N/A</option>
                <option *ngFor="let selectcategory of allcategories" [value]="selectcategory?.id">{{selectcategory?.name | titlecase}}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Skill Types</label>
              <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="formskills" title="Select Skill" multiple class="selectpicker skill font-oswald w-100">
                <option value="">Select Skill</option>
                <option *ngFor="let selectskill of allskills" [value]="selectskill?.id">{{selectskill?.name | titlecase}}</option>
              </select>
              <div class="invalid-feedback d-block"
                  *ngIf="f2['formskills']?.errors?.['required'] && f2['formskills'].touched && f2['formskills']?.invalid">
                  Please select skill.
              </div>
            </div>
          </div>
          <label class="form-label">Coaching Tips</label>
          <hr/>
          <ng-container formArrayName="forminstructions">
            <ng-container *ngFor="let forminstructionsForm of forminstructions?.controls; let i = index">
              <div class="row mb-2" [formGroupName]="i">
                <div class="col-md-10 form-group">
                  <input type="textarea" class="form-control" formControlName="instruction">
                  <div class="invalid-feedback d-block"
                      *ngIf="f2['forminstructions']['controls'][i]['controls']['instruction'].errors?.['required'] && f2['forminstructions']['controls'][i]['controls']['instruction']?.touched && f2['forminstructions']['controls'][i]['controls']['instruction']?.invalid">
                      Please write coaching tips.
                  </div>
                </div>
                
                <div class="col-md-2 form-group">
                  <!-- <label class="form-label">Remove</label> -->
                  <div>
                    <button class="btn btn-sm btn-danger" (click)="deleteforminstructions(i)"><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <button type="button" class="btn btn-secondary btn-sm me-3" (click)="addInstructions()">Add Coaching Tips</button>
          <br/>
          <br/>
          <label class="form-label">Common Errors</label>
          <hr/>
          <ng-container formArrayName="formerrors">
            <ng-container *ngFor="let formerrorsForm of formerrors?.controls; let i = index">
              <div class="row mb-2" [formGroupName]="i">
                <div class="col-md-10 form-group">
                  <input type="textarea" class="form-control" formControlName="error">
                  <div class="invalid-feedback d-block"
                      *ngIf="f2['formerrors']['controls'][i]['controls']['error'].errors?.['required'] && f2['formerrors']['controls'][i]['controls']['error']?.touched && f2['formerrors']['controls'][i]['controls']['error']?.invalid">
                      Please write error.
                  </div>
                </div>
                
                <div class="col-md-2 form-group">
                  <!-- <label class="form-label">Remove</label> -->
                  <div>
                    <button class="btn btn-sm btn-danger" (click)="deleteformerrors(i)"><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <button type="button" class="btn btn-secondary btn-sm me-3" (click)="addErrors()">Add Common Errors</button>
          <br/>
          <br/>
          <label class="form-label">Legalities</label>
          <hr/>
          <ng-container formArrayName="formtips">
            <ng-container *ngFor="let formtipsForm of formtips?.controls; let i = index">
              <div class="row mb-2" [formGroupName]="i">
                <div class="col-md-10 form-group">
                  <input type="textarea" class="form-control" formControlName="tip">
                  <div class="invalid-feedback d-block"
                      *ngIf="f2['formtips']['controls'][i]['controls']['tip'].errors?.['required'] && f2['formtips']['controls'][i]['controls']['tip']?.touched && f2['formtips']['controls'][i]['controls']['tip']?.invalid">
                      Please write legalities.
                  </div>
                </div>
                
                <div class="col-md-2 form-group">
                  <!-- <label class="form-label">Remove</label> -->
                  <div>
                    <button class="btn btn-sm btn-danger" (click)="deleteformtips(i)"><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <button type="button" class="btn btn-secondary btn-sm me-3" (click)="addTips()">Add Legalities</button>
          <br/>
          <br/>
          <label class="form-label">Notes</label>
          <hr/>
          <ng-container formArrayName="formnotes">
            <ng-container *ngFor="let formnotesForm of formnotes?.controls; let i = index">
              <div class="row mb-2" [formGroupName]="i">
                <div class="col-md-10 form-group">
                  <input type="textarea" class="form-control" formControlName="note">
                  <div class="invalid-feedback d-block"
                      *ngIf="f2['formnotes']['controls'][i]['controls']['note'].errors?.['required'] && f2['formnotes']['controls'][i]['controls']['note']?.touched && f2['formnotes']['controls'][i]['controls']['note']?.invalid">
                      Please write note.
                  </div>
                </div>
                
                <div class="col-md-2 form-group">
                  <!-- <label class="form-label">Remove</label> -->
                  <div>
                    <button class="btn btn-sm btn-danger" (click)="deleteformnotes(i)"><i class="fa fa-trash"></i></button>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <button type="button" class="btn btn-secondary btn-sm me-3" (click)="addNotes()">Add Other Note</button>
          <br/>
          <br/>
          <label class="form-label" *ngIf="alloptions && alloptions.length>0">Options</label>
          <ng-container formArrayName="formoptions" *ngIf="alloptions && alloptions.length>0">
            <div class="row form-group mb-0">
              <div class="col-4"><label class="form-label">Option</label></div>
              <div class="col-8"><label class="form-label">Value</label></div>
            </div>
            
            <ng-container *ngFor="let formoptionsForm of formoptions?.controls; let i = index">
              <div class="row mb-2" [formGroupName]="i">
                <div class="col-4 form-group">
                  <input type="hidden" formControlName="option" class="form-control" value="{{alloptions[i].option_id}}">
                  <div>{{alloptions[i].title}}</div>
                </div>
                <div class="col-8 form-group">
                  <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" formControlName="choice" title="Select Choice" class="selectpicker choiceselect{{i}} level font-oswald w-100">
                    <option value="">Select Choice</option>
                    <option *ngFor="let choice of alloptions[i].optionschoices" [value]="choice?.choice_id">{{choice?.title | titlecase}}</option>
                  </select>
                  <div class="invalid-feedback d-block"
                      *ngIf="f2['formoptions']['controls'][i]['controls'].choice?.errors?.['required'] && f2['formoptions']['controls'][i]['controls'].choice?.touched && f2['formoptions']['controls'][i]['controls'].choice?.invalid">
                      Please select choice.
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <br/>
          <br/>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary me-3" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-dark btn-gold">Submit <i *ngIf="submitting" class="fa fa-spinner fa-spin"></i></button>
        </div>
      </form>
    </div>
  </div>
</div>